import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import type { updateProjectSchema } from "backend/src/schemas/projectSchema";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Project } from "../query/useProjectQuery";
import { QUERY_KEYS } from "../query/querykeys";

type ProjectApiResponse = ResponseType<Project>;

function useProjectMutation(id:string, shouldInvalidate: boolean = true) {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<ProjectApiResponse>["response"],
    AxiosResponseAndError<ProjectApiResponse>["error"],
    z.infer<typeof updateProjectSchema> &{projectId?:string}
  >({
    mutationFn: (data) =>
      ApiRequest.put<ProjectApiResponse>(
        `${requestURLs.project}/${id ? id : data.projectId}`,
        data,
      ),
    onSuccess: async (res) => {
      if (!shouldInvalidate) return;
      const updatedId = res.data?.data.projectId ?? id;
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getProjects] }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getProjectsNocal],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.portfolioDashboard],
        }),
        updatedId
          ? queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.getProjectDetails, updatedId],
            })
          : Promise.resolve(),
      ]);
    },
  });

  return mutation;
}
export default useProjectMutation;